import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default class ApexChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [
                {
                    data: [...props.data],
                },
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'bar',
                    events: {
                        click: function (chart, w, e) {
                            // console.log(chart, w, e)
                        },
                    },
                    toolbar: {
                        show: false,
                    },
                },
                colors: [...props.colors],
                plotOptions: {
                    bar: { borderRadius: 10, columnWidth: '45%', horizontal: true, distributed: true },
                },
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                xaxis: {
                    categories: [...props.label],
                    labels: {
                        style: {
                            colors: [...props.colors],
                            fontSize: '8px',
                        },

                        rotate: 0,
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: [...props.colors],
                            fontSize: '8px',
                        },

                        rotate: 0,
                    },
                },
            },
        };
    }

    render() {
        return (
            <div id="chart2">
                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} />
            </div>
        );
    }
}
